import React from 'react';

import { RingSpinner  } from 'react-spinner-overlay'

export const Loading = (props: any) => {
  const loading = props.loading

  return (
    <React.Fragment>
        <RingSpinner loading={loading}　color="#ffae00" />
    </React.Fragment>
  )


}





